
<div class="w-full flex flex-row justify-center font-rubik">
  <div class="w-full flex flex-col justify-center items-center max-w-1216 py-12 find-inventory-bg-color">
    <div class="w-full flex flex-col justify-center items-center" style="z-index: 1;">
      <div class="find-inventory-container w-full max-w-1012 flex flex-col 1216-bp:flex-row">
        <div class="w-full flex flex-col 1216-bp:justify-end gap-4 1216-bp:gap-2 h-2/6 1216-bp:h-auto find-inventory-input-container">
          <div class="flex justify-center 1216-bp:justify-start">
            <div class="find-inventory-h2-container">
              <h2 class="find-inventory-h2 font-rubik">Find an inventory</h2>
            </div>
          </div>
          <div>
            <div class="flex flex-col 1216-bp:flex-row justify-between items-center gap-2 1216-bp:gap-1">
              <div class="input-container relative flex flex-row justify-around items-center">
                <div class="flex items-center gap-1 geo-location-container">
                  <geolocate @success="searchByCoordinates" :showIcon="false" :onlyIcon="true" />
                  <img v-if="loading" class="animate-spin h-3" src="@/images/spinner.svg" alt="Loading">
                </div>
                <input
                  @keyup.enter="search"
                  @click="coordinates = null"
                  v-model="query"
                  :class="{ 'is-danger': error }"
                  class="bg-white w-full focus:ring-0 focus:outline-none pl-3"
                  type="search"
                  placeholder="Where are you located?"
                />
                <button @click="search" class="flex justify-center items-center">
                  <img class="h-7" src="@/images/find-inventory/search.svg" alt="Search">
                </button>
                <div
                  v-if="cities.length && query.length > 0"
                  role="menu"
                  class="dropdown-content absolute"
                >
                  <p class="dropdown-item"><b>We found multiple results...</b></p>
                  <a v-for="city in cities" :key="city.id" :href="cityPath(city.node)" class="dropdown-item">
                    {{ city.node.name }}, {{ city.node.stateId | upcase }}
                  </a>
                </div>
                <div v-if="error" class="error-message absolute">
                  {{ error }}
                  <b><a @click.prevent="resetSearch()">Try Again</a></b>
                </div>
              </div>
              <toggle class=" mr-10 pr-4" @toggleValue="setToggleOption" />
            </div>
          </div>
        </div>
        <div class="hidden 1216-bp:block w-full find-inventory-map-container">
          <img class="usa-map" src="@/images/find-inventory/us-map.svg" alt="USA Map" />
        </div>
        <div class="1216-bp:hidden w-full flex justify-center items-center h-4/6 find-inventory-map-container">
          <img class="usa-map-mobile" src="@/images/find-inventory/us-map.svg" alt="USA Map" />
        </div>
      </div>
    </div>
  </div>
</div>
